import { render, staticRenderFns } from "./EditAddress.vue?vue&type=template&id=69a59a4c&scoped=true"
import script from "./EditAddress.vue?vue&type=script&lang=js"
export * from "./EditAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a59a4c",
  null
  
)

export default component.exports